import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as CloseGreenSvg } from 'assets/ic-close-green-notification.svg';
import { ReactComponent as CloseRedSvg } from 'assets/ic-close-red-notification.svg';
import { ReactComponent as CloseYellowSvg } from 'assets/ic-close-yellow-notification.svg';

const styles = (theme) => ({
  success: {
    backgroundColor: '#e1efd9',
    borderLeft: `4px solid ${theme.palette.common.success}`,
    color: theme.palette.common.success,
  },
  error: {
    backgroundColor: '#efccd2',
    borderLeft: `4px solid ${theme.palette.common.error}`,
    color: theme.palette.common.error,
  },
  note: {
    backgroundColor: '#fdf0cc',
    borderLeft: ' 4px solid #e5ad12',
    color: '#e5ad12',
  },
  message: {
    font: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 'bold',
  },
});

class Alert extends React.PureComponent {
  getIcon = (variant) => {
    if (variant === 'success') return CloseGreenSvg;
    if (variant === 'error') return CloseRedSvg;
    if (variant === 'note') return CloseYellowSvg;
  };
  render() {
    const {
      variant,
      message,
      classes,
      visible,
      onClose,
      closeIcon,
    } = this.props;

    let hidden = !visible;
    let CloseIcon = closeIcon;
    if (!closeIcon) {
      CloseIcon = this.getIcon(variant);
    }

    return (
      <div hidden={hidden}>
        <SnackbarContent
          className={classes[variant]}
          display="none"
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              {message}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={onClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

Alert.propTypes = {
  classes: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['success', 'error', 'note']).isRequired,
  message: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  closeIcon: PropTypes.object,
};

export default withStyles(styles)(Alert);
